class APIS {
	apis() {
		return {
			listing: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/shell/campaign'
			}
		};
	}
}

export default new APIS();
